import { render, staticRenderFns } from "./VisualizarEsclarecimentoImpugnacao.vue?vue&type=template&id=5c78886e&"
import script from "./VisualizarEsclarecimentoImpugnacao.vue?vue&type=script&lang=js&"
export * from "./VisualizarEsclarecimentoImpugnacao.vue?vue&type=script&lang=js&"
import style0 from "./VisualizarEsclarecimentoImpugnacao.vue?vue&type=style&index=0&id=5c78886e&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports